import { SET_READ_ONLY } from "../../actionTypes/actionsTypes";
import { LocalAction } from "../../types";

export const setReadOnly = (valid: boolean): LocalAction => ({
    type: SET_READ_ONLY,
    data: valid
});